import momentTimezone from "moment-timezone";

// UTC time
export const formatIST = (dateStr) => {
  if (!dateStr) return "-";
  const utcTime = momentTimezone.utc(dateStr);
  // Convert to Asia/Kolkata timezone
  const ISTFormat = utcTime.tz("Asia/Kolkata");

  return ISTFormat.format("DD-MM-YYYY h:mm A"); // Output: 2024-05-22 08:32:00
};
